module.exports = __webpack_public_path__ + "static/media/search.0a4282d9.svg";